export default {
  dataIterator: {
    rowsPerPageText: 'Elementi per pagina:',
    rowsPerPageAll: 'Tutti',
    pageText: '{0}-{1} di {2}',
    noResultsText: 'Nessun risultato trovato',
    nextPage: 'Pagina seguente',
    prevPage: 'Pagina precedente'
  },
  dataTable: {
    rowsPerPageText: 'Righe per pagina:'
  },
  noDataText: 'Nessun elemento disponibile'
}
